// #  Load primary system assets
import assets from './app/core/engine/assets/autoload'
// #  Import resources
import React from 'react'
import { render } from 'react-dom'
import { Router, browserHistory } from 'react-router'
// import routes and pass them into <Router/>
import routes from './app/components/Routes/'
// #  Import fixed features
//import Header from './app/features/Header/'

render(
  <Router routes={routes} history={browserHistory}/>,
  document.getElementById('app')
)

// #  Component listens for when a url changes - have it update nav
browserHistory.listen(function(ev) {
  (function( $ ) {
    $(".nav-sidebar li.active").removeClass("active");
    $(".nav-sidebar").find("a[href='"+ev.pathname+"']").parent().addClass("active");
  })( jQuery );
});


// WEBPACK FOOTER //
// index.js